'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customBg = customBg;

var _index = require('./index');

/**
 * 定制背景图
 *
 * @export
 * @param {string} imageUrl 背景图链接
 * @return {object} React style object
 */
function customBg(imageUrl) {
  return (0, _index.isUrl)(imageUrl) ? { backgroundImage: 'url(' + imageUrl + ')' } : {};
}